import React from "react";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";

export default function CostNotSetField({ disabled, value, onChange }) {
  const handleChange = (e) => {
    onChange({ cost_not_set: e.target.checked });
  };

  return (
    <Grid
      item
      xs={12}
      sm={4}
      sx={{
        borderLeft: 1,
        borderColor: "#F2F3F4",
        paddingLeft: "10px",
        paddingBottom: "20px",
      }}
    >
      <FormControlLabel
        label="金額設定がない案件も表示"
        control={<Checkbox checked={!!value} onChange={handleChange} />}
        disabled={disabled}
      />
    </Grid>
  );
}